<template>
  <div class="informations">
    <v-layout wrap row>
      <v-flex lg6>
        <v-card flat>
          <v-card-title>Dados do Tier</v-card-title>
          <v-card-text>
            <v-layout class="mb-2" wrap row>
              <v-flex lg6>
                <h4 class="secondary--text">
                  Nome
                </h4>
                <span class="grey--text darken-4 mt-4">{{ tier.name }}</span>
                <h4 class="secondary--text mt-4">
                  Features
                </h4>
                <ul>
                  <li v-for="(feature, index) in tier.features" :key="index">
                    {{ feature.title }}
                  </li>
                </ul>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex lg6>
        <v-card flat>
          <v-card-title>Parceiros</v-card-title>
          <v-card-text>
            <v-layout class="mb-2" wrap row>
              <v-flex lg6>
                <h4 class="secondary--text mt-4">
                  Parceiros
                </h4>
                <ul>
                  <li v-for="(partner, index) in tier.partners" :key="index">
                    {{ partner.name }}
                  </li>
                </ul>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>

export default {
  name: 'Informations',
  props: {
    tier: {
      type: Object,
      default: () => { }
    }
  },

}
</script>